var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import { SingleDatePicker } from "react-dates";
import CampaignPrimarySidebar from "../../../Container/Campaign/CampaignPrimarySidebar";
import PrimarySidebarLayout from "../../../Layout/PrimarySidebarLayout";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import ContentTemplateService from "../../../../Services/ContentTemplate.service";
import FAIcon from "../../../UI/FAIcon/FAIcon";
import { getCampaignTemplateDetailPath, getCampaignTemplateNewPath, } from "./CampaignTemplateRoutes";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import DateService from "../../../../Services/Shared/Date.service";
import SecondaryNavButton from "../../../UI/SecondaryNav/SecondaryNavButton";
import NumberService from "../../../../Services/Shared/Number.service";
import DeprecatedSelect from "../../../UI/DeprecatedSelect/DeprecatedSelect";
import useUniqueId from "../../../Hooks/useUniqueId";
import useHasPermission from "../../../Hooks/useHasPermission";
import CampaignTypeService from "../../../../Services/CampaignType.service";
import { useVirtualizedApp } from "../../../Hooks/useVirtualizedApp";
import PageTitle from "../../../UI/PageTitle/PageTitle";
const PAGE_SIZE = 20;
const QUERY_DEFAULT = "";
const CAMPAIGN_TYPES_DEFAULT = null;
const MODIFIED_DATE_FROM_DEFAULT = null;
const MODIFIED_DATE_TO_DEFAULT = null;
const DEFAULT_SEARCH = {
    query: QUERY_DEFAULT,
    campaignTypes: CAMPAIGN_TYPES_DEFAULT,
    modifiedDateFrom: MODIFIED_DATE_FROM_DEFAULT,
    modifiedDateTo: MODIFIED_DATE_TO_DEFAULT,
};
const CampaignTemplateList = (props) => {
    const virtualizedAppContext = useVirtualizedApp();
    const [query, setQuery] = React.useState(QUERY_DEFAULT);
    const [campaignTypes, setCampaignTypes] = React.useState(CAMPAIGN_TYPES_DEFAULT);
    const [modifiedDateFrom, setModifiedDateFrom] = React.useState(MODIFIED_DATE_FROM_DEFAULT);
    const [modifiedDateTo, setModifiedDateTo] = React.useState(MODIFIED_DATE_TO_DEFAULT);
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const runSearch = () => {
        setSearchArgs({
            query,
            campaignTypes,
            modifiedDateFrom,
            modifiedDateTo,
        });
    };
    const [modifiedDateToFocused, setModifiedDateToFocused] = React.useState(false);
    const [modifiedDateFromFocused, setModifiedDateFromFocused] = React.useState(false);
    const makeId = useUniqueId()[1];
    const { table, dataState } = usePagedSortedTable({
        hover: true,
        searchArgs,
        noDataComponent: "No Templates",
        getData: (sort, page, search) => {
            var _a, _b, _c;
            return ContentTemplateService.searchCampaignTemplates({
                query: search.query,
                campaignTypeIds: (_a = search.campaignTypes) === null || _a === void 0 ? void 0 : _a.map((type) => type.id),
                modifiedBefore: (_b = search.modifiedDateTo) === null || _b === void 0 ? void 0 : _b.toDate(),
                modifiedAfter: (_c = search.modifiedDateFrom) === null || _c === void 0 ? void 0 : _c.toDate(),
                isExpired: false,
                // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
                virtualizedAppName: virtualizedAppContext.name
                    ? virtualizedAppContext.name
                    : null,
            }, {
                max: PAGE_SIZE,
                offset: page * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: (sort === null || sort === void 0 ? void 0 : sort.order) === "asc" ? "ascnullsfirst" : "descnullslast",
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Name",
                sortId: "CONTENT_TEMPLATE_NAME",
            },
            {
                title: "Type",
                sortId: "CONTENT_TEMPLATE_TYPE_NAME",
            },
            {
                title: "Modified",
                sortId: "CONTENT_TEMPLATE_MODIFIED_DATE",
            },
            {
                title: "Modified By",
                sortId: "CONTENT_TEMPLATE_MODIFIED_BY",
            },
            {
                title: "Campaigns",
                align: "end",
                sortId: "CONTENT_TEMPLATE_USAGE_COUNT",
            },
        ],
        initialSort: { sort: "CONTENT_TEMPLATE_MODIFIED_DATE", order: "desc" },
        rows: ({ data }) => data.map((template) => {
            var _a, _b, _c, _d, _e;
            return [
                _jsx(Link, { to: getCampaignTemplateDetailPath(template.id), children: template.name }, 0),
                template.campaignTypeName,
                DateService.displayLong(template.modifiedDate),
                template.modifiedBy.fullName,
                template.usageCount || 0,
                ((_a = template.metrics) === null || _a === void 0 ? void 0 : _a.sendCount) || 0,
                NumberService.asPercentage(((_b = template.metrics) === null || _b === void 0 ? void 0 : _b.deliveredRate) || 0) + "%",
                NumberService.asPercentage(((_c = template.metrics) === null || _c === void 0 ? void 0 : _c.openRate) || 0) + "%",
                NumberService.asPercentage(((_d = template.metrics) === null || _d === void 0 ? void 0 : _d.bounceRate) || 0) + "%",
                NumberService.asPercentage(((_e = template.metrics) === null || _e === void 0 ? void 0 : _e.clickThroughRate) || 0) +
                    "%",
            ];
        }),
    });
    const canCreateCampaignTemplates = useHasPermission("CAN_CREATE_CAMPAIGN_CONTENT_TEMPLATES");
    return (_jsx(PrimarySidebarLayout, { sidebar: (setIsOpen) => (_jsx(CampaignPrimarySidebar, { setIsOpen: setIsOpen, templatesOpen: true })), sidebarSize: "sm", children: () => {
            var _a;
            return (_jsx(SecondaryNavLayout, { nav: _jsxs("div", { className: "d-flex", children: [canCreateCampaignTemplates && (_jsxs(Link, { className: "btn btn-link", to: getCampaignTemplateNewPath(), children: [_jsx(FAIcon, { className: "mr-2", icon: "plus", type: "fal" }), _jsx("span", { className: "d-none d-lg-inline-block", children: "New" })] })), _jsx(SecondaryNavButton, { icon: "sync", label: "Refresh", disabled: dataState.isLoading, spin: dataState.isLoading, onClick: () => runSearch() })] }), children: _jsxs("div", { className: "container-fluid pt-3 pb-5 fullMinHeightMinusSecondaryNav bg-light", children: [_jsxs(PageTitle, { children: ["Templates", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total) == null ? "" : `(${dataState.data.total})`] }), _jsxs("div", { className: "mb-3 form-inline", children: [_jsx("div", { className: "form-group mr-3 mt-2", children: _jsxs("div", { className: "input-group", children: [_jsx("input", { className: "form-control", type: "text", placeholder: "Search", value: query, onKeyPress: (e) => {
                                                    if (e.key === "Enter") {
                                                        runSearch();
                                                    }
                                                }, onChange: (e) => setQuery(e.target.value) }), _jsx("div", { className: "input-group-append input-group-append-blend", children: _jsx("button", { className: "btn btn-outline-secondary", onClick: () => runSearch(), children: _jsx(FAIcon, { icon: "search" }) }) })] }) }), _jsx("div", { className: "form-group mr-3 mt-2", children: _jsx(DeprecatedSelect.Async, { loadOptions: (search) => __awaiter(void 0, void 0, void 0, function* () {
                                            return ({
                                                options: yield CampaignTypeService.restrictedList({
                                                    query: search,
                                                }),
                                            });
                                        }), style: { width: 300 }, multi: true, value: campaignTypes, onChange: setCampaignTypes, placeholder: "Type", "aria-label": "Campaign Type", valueKey: "id", labelKey: "title" }) }), _jsxs("div", { className: "form-group mr-3 mt-2", children: [_jsx("label", { htmlFor: makeId("updatedFromDate"), className: "mr-2", children: "Modified" }), _jsx("label", { htmlFor: makeId("updatedToDate"), className: "sr-only", children: "Modified Date To" }), _jsxs("div", { className: "d-flex react-date-single-picker-group", id: "startGroup", children: [_jsx(SingleDatePicker, { showClearDate: true, numberOfMonths: 1, displayFormat: "M/D/YYYY", date: modifiedDateFrom, id: makeId("updatedFromDate"), placeholder: "From", onDateChange: (date) => {
                                                        if (!date && !modifiedDateFrom) {
                                                            return date;
                                                        }
                                                        // @ts-expect-error - TS2345 - Argument of type 'Moment | null' is not assignable to parameter of type 'SetStateAction<null>'.
                                                        setModifiedDateFrom(date);
                                                        // @ts-expect-error - TS2339 - Property 'isAfter' does not exist on type 'never'.
                                                        if (modifiedDateTo && !modifiedDateTo.isAfter(date)) {
                                                            // @ts-expect-error - TS2345 - Argument of type 'Moment | null' is not assignable to parameter of type 'SetStateAction<null>'.
                                                            setModifiedDateTo(date);
                                                        }
                                                        return date;
                                                    }, focused: modifiedDateFromFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setModifiedDateFromFocused(focused), small: true }), _jsx(SingleDatePicker, { numberOfMonths: 1, displayFormat: "M/D/YYYY", showClearDate: true, id: makeId("updatedToDate"), placeholder: "To", date: modifiedDateTo, onDateChange: (date) => {
                                                        if (!date && !modifiedDateTo) {
                                                            return date;
                                                        }
                                                        // @ts-expect-error - TS2345 - Argument of type 'Moment | null' is not assignable to parameter of type 'SetStateAction<null>'.
                                                        setModifiedDateTo(date);
                                                        if (modifiedDateFrom &&
                                                            // @ts-expect-error - TS2339 - Property 'isBefore' does not exist on type 'never'.
                                                            !modifiedDateFrom.isBefore(date)) {
                                                            // @ts-expect-error - TS2345 - Argument of type 'Moment | null' is not assignable to parameter of type 'SetStateAction<null>'.
                                                            setModifiedDateFrom(date);
                                                        }
                                                        return date;
                                                    }, focused: modifiedDateToFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setModifiedDateToFocused(focused), small: true })] })] }), _jsx("div", { className: "mt-2", children: _jsx("button", { className: "btn btn-primary", onClick: () => runSearch(), children: "Search" }) })] }), table] }) }));
        } }));
};
export default CampaignTemplateList;
